import { getHostCarrierCode } from '../../../utils/common-util';
import {
   FARE_STATUS,
   USER_ACTION_CODE_FARES_SCREEN,
} from '../../../utils/constants';
import { DateUtil } from '../../../utils/date-util';

function validateEmptyValues(value) {
   const isArray = Array.isArray(value);
   return isArray ? value?.join(',')?.length > 0 : value?.length > 0;
}

const getSectionPayload = (queryObject, sectionName) => {
   const section = queryObject?.find(
      (section) => section.categoryName === sectionName
   );

   const dataFields = section?.categoryDetails?.filter(({ values }) =>
      validateEmptyValues(values)
   );

   const payload = dataFields.map(({ key, values, operator }) => {
      return {
         key: key,
         value: values.join(','),
         operator: operator,
      };
   });

   return payload;
};

export function createApiPayload(queryData, loadTime) {
   const identifiersPayload = getSectionPayload(queryData, 'Identifier');
   const tablePayload = getSectionPayload(queryData, 'Table');
   const productsPayload = getSectionPayload(queryData, 'Products');
   const searchPayload = getSectionPayload(queryData, 'Search');
   const fareValuePayload = getSectionPayload(queryData, 'Fare Value');
   const rulePayload = getSectionPayload(queryData, 'Rule');
   const footnotePayload = getSectionPayload(queryData, 'Footnote');
   const distributionPayload = getSectionPayload(queryData, 'Distribution');
   const fareClassPayload = getSectionPayload(queryData, 'Fare Class');
   const brandPayload = getSectionPayload(queryData, 'Brand');
   const marketPayload = getSectionPayload(queryData, 'Market');

   const apiPayload = {
      identifiers: identifiersPayload,
      table: tablePayload,
      products: productsPayload,
      search: searchPayload,
      fareValues: fareValuePayload,
      rules: rulePayload,
      footnotes: footnotePayload,
      distributions: distributionPayload,
      fareClass: fareClassPayload,
      brands: brandPayload,
      markets: marketPayload,
   };

   const filteredApiPayload = Object.fromEntries(
      Object.entries(apiPayload).filter(
         // eslint-disable-next-line no-unused-vars
         ([_, value]) => value && value?.length > 0
      )
   );

   const finalApiPayload = {
      bqJobInfo: null,
      pageToken: null,
      hostCarrier: sessionStorage.getItem('carrierCode') ?? null,
      latestLoadTransmission: loadTime,
      productType: 'I',
      ...filteredApiPayload,
   };

   return finalApiPayload;
}

export function createFareKey(record) {
   const fareKey = [
      record.carrierCode || 'null',
      record.origin || 'null',
      record.destination || 'null',
      record.fareClassCode || 'null',
      record.currencyCode || 'null',
      record.roundTripIndicator === '3' ? '1' : record.owrt || 'null',
      record.routingNumber || 'null',
      record.tariffNumber || 'null',
      record.footnoteCode || 'null',
   ].join('-');

   return fareKey;
}

export const getUserActionCode = (record) => {
   if (record.isNewRow) {
      return USER_ACTION_CODE_FARES_SCREEN.NEW;
   } else if (record.isCancelledRow) {
      return USER_ACTION_CODE_FARES_SCREEN.CLOSE;
   } else return USER_ACTION_CODE_FARES_SCREEN.UPDATE;
};

export const cancelFareRecords = (rowsToCancel, gridApi) => {
   const todaysDate = DateUtil.formatDate(
      new Date(),
      DateUtil.DATE_FORMATS.DD_MMM_YY
   )
      .toString()
      .toUpperCase();

   const updatedRecords = rowsToCancel.map((node) => {
      const updatedRecord = {
         ...node.data,
         userActionCode: USER_ACTION_CODE_FARES_SCREEN.CLOSE,
         discontinueDate: todaysDate,
         effectiveDate: todaysDate,
         isCancelledRow: true,
         isEdited: true,
      };
      if (!node.data.originalData) {
         updatedRecord['originalData'] = node.data;
      }

      return updatedRecord;
   });

   gridApi.applyTransaction({
      update: updatedRecords,
   });
};

export const getRowClasses = () => ({
   'ag-pink-row': (params) => params.data.status === FARE_STATUS.WORKING,
   'ag-yellow-row': (params) => params.data.status === FARE_STATUS.DISTRIBUTED,
   'ag-grey-row': (params) =>
      params.data.userActionCode &&
      params.data.userActionCode === USER_ACTION_CODE_FARES_SCREEN.CLOSE,
});

export const contextMenuConfig = {
   enableInsertNewRow: true,
   enableInsertTemplate: true,
   enableDelete: true,
   enableSave: true,
   enableExport: true,
   enableUndo: true,
   enableCancel: true,
   preventDefaultRowDeletion: true,
};

export const createSaveFarePayload = (dataToSave, distributionGroupNumber) => {
   const payload = dataToSave?.map((record) => {
      const fareKey = createFareKey(record);
      const userActionCode = record.userActionCode || getUserActionCode(record);

      return {
         origin: record.origin,
         destination: record.destination,
         fareKey: fareKey,
         carrierCode: record.carrierCode,
         fareClassCode: record.fareClassCode,
         tariffNumber: record.tariffNumber,
         footnoteCode: record.footnoteCode,
         routingNumber: record.routingNumber,
         roundTripIndicator: record.roundTripIndicator,
         currencyCode: record.currencyCode,
         fareAmount: record.fareAmount,
         effectiveDate: record.effectiveDate,
         actionCode: record.actionCode,
         userActionCode: userActionCode,
         hostCarrier: getHostCarrierCode(),
         dgNumber: distributionGroupNumber,
         rowIndex: record.rowIndex,
         id: record.id,
         status: record.status,
      };
   });

   return payload;
};
